module.exports = __webpack_public_path__ + "static/media/muscleSide.55387718.png";